import { useContext } from 'react';
import { Context } from '../AccelProvider/AccelProvider';

export function useDevice() {
    const ctx = useContext(Context);
    return ctx.deviceStore;
}
